import '.j{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.b1{gap:0.5rem;}.ssr-plugin'
import '.cr{font-size:0.875rem;}.ssr-plugin'
import '.dc{color:var(--shades-gray-600);}.ssr-plugin'
import { Avatar, AvatarSize, AvatarShape } from '@app/components/core/avatar/Avatar'
import { styled } from 'inlines'

interface AuthorProps {
  avatarSrc?: string
  avatarSize?: AvatarSize
  avatarShape?: AvatarShape
  name: string
  description?: string
}

export const Author = ({
  avatarSrc,
  avatarSize = 'small',
  avatarShape = 'circle',
  name,
  description,
}: AuthorProps) => {
  return (
    <div className="j r b1"
    >
      <Avatar size={avatarSize} image={avatarSrc} labelSource={name} shape={avatarShape} />

      <div>
        <styled.strong>{name}</styled.strong>
        <div className="cr dc"
        >
          {description}
        </div>
      </div>
    </div>
  )
}
